<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row v-for="(pilotage, index) in pilotages" :key="'pilotage-' + index">
        <v-col cols="12" class="pb-0">
          <span class="text-h6">Pilotage: #{{index + 1}}</span>
          <v-btn color="red" icon @click="removeServiceEntry(index, pilotage.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="!operation.is_draft">
          <v-switch
            dense
            hide-details
            v-model="pilotage.metadata.arrange_by_owner"
            label="Arrange By Principal?"
            class="mt-0 pt-0"
          ></v-switch>
        </v-col>
        <!-- <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-switch
            dense
            hide-details
            v-model="serviceOptFormArrival.metadata.rush_request"
            label="Cancellation / Amendment?"
            class="mt-1"
            @change="initCalculation"
          ></v-switch>
        </v-col> -->
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner">
          <v-select
            label="Pilot Type"
            placeholder="Select pilot type"
            outlined
            dense
            v-model="pilotage.metadata.pilot_type"
            prepend-inner-icon="mdi-ship-wheel"
            :items="pilotageTypes"
            :rules="requiredRules()"
            @change="onPilotTypeChange(index)"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Inward'">
          <v-datetime-picker
            :ref="`arrivalPilotInward_${index}`"
            label="Pilot Inward Time"
            v-model="pilotage.metadata.pilot_inward_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotInwardField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Outward'">
          <v-datetime-picker
            :ref="`arrivalPilotOutward_${index}`"
            label="Pilot Outward Time"
            v-model="pilotage.metadata.pilot_outward_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotOutwardField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Inward'">
          <v-datetime-picker
            :ref="`arrivalPilotDisembarkInward_${index}`"
            label="Pilot Disembark Inward Time"
            v-model="pilotage.metadata.pilot_disembark_inward_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotDisembarkInwardField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Outward'">
          <v-datetime-picker
            :ref="`arrivalPilotDisembarkOutward_${index}`"
            label="Pilot Disembark Outward Time"
            v-model="pilotage.metadata.pilot_disembark_outward_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotDisembarkOutwardField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Shifting'">
          <v-datetime-picker
            :ref="`arrivalPilotInwardShifting_${index}`"
            label="Pilot Inward Shifting Time"
            v-model="pilotage.metadata.pilot_inward_shifting_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotInwardShiftingField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner && pilotage.metadata.pilot_type === 'Shifting'">
          <v-datetime-picker
            :ref="`arrivalPilotOutwardShifting_${index}`"
            label="Pilot Outward Shifting Time"
            v-model="pilotage.metadata.pilot_outward_shifting_time"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, id: `arrivalPilotOutwardShiftingField_${index}`}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col>
        <!-- <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-datetime-picker
            ref="arrivalPilotStation"
            label="Arrival Pilot Station"
            v-model="serviceOptFormArrival.metadata.arrival_pilot_station"
            :textFieldProps="{dense: true, readonly: true, 'prepend-inner-icon': 'mdi-calendar', outlined: true, rules: requiredRules, id: 'arrivalPilotStationField'}"
          >
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-calendar-clock</v-icon>
            </template>
          </v-datetime-picker>
        </v-col> -->
        <!-- <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-text-field
            label="Arrival Duration(In Hours)"
            placeholder="Enter duration in hours"
            outlined
            dense
            type="number"
            step="0.5"
            v-model="serviceOptFormArrival.metadata.duration"
            prepend-inner-icon="mdi-clock-in"
            @input="initCalculation"
            disabled
          ></v-text-field>
        </v-col> -->
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Pilotage Service Charges"
            placeholder="Enter Pilotage Service Charges"
            outlined
            dense
            type="number"
            v-model="pilotage.amount"
            prepend-inner-icon="mdi-currency-usd"
            :rules="amountRules(index)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner">
          <v-select
            label="Supplier"
            placeholder="Select arrival supplier"
            outlined
            dense
            v-model="pilotage.card_id"
            prepend-inner-icon="mdi-account"
            :items="suppliersList"
            :rules="supplierRules(index)"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!pilotage.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-select
            label="Tax"
            placeholder="Select Tax"
            outlined
            dense
            v-model="pilotage.metadata.tax"
            prepend-inner-icon="mdi-cash-fast"
            :items="taxes"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-textarea
            label="Remarks"
            placeholder="Enter Remarks"
            outlined
            dense
            hide-details
            :rows="2"
            v-model="pilotage.remarks"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
          <v-textarea
            label="Accounts Remarks"
            placeholder="Enter Accounts Remarks"
            outlined
            background-color="light-blue lighten-5"
            dense
            hide-details
            :rows="2"
            v-model="pilotage.accounts_remarks"
            class="accounts-remarks-field"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-col cols="12" class="pt-7">
        <v-btn color="primary" @click="addPilotage">Add</v-btn>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
          @click="saveDetails">Save</v-btn>
      </v-col>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';
  import _ from 'lodash';

  export default {
    name: 's-services-opted-pilot-service',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      isDraft: {
        type: Boolean,
        default: false,
      },
      servicesOpted: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        loading: false,
        form: false,
        rules,
        pilotages: [],
        pilotageTypes: [
          'Inward',
          'Outward',
          'Shifting',
          'Cancellation'
        ],
        serviceOptForm: {
          service_catalog_id: null,
          card_id: null,
          bill_type: 'Pilotage',
          amount: 0,
          remarks: '',
          accounts_remarks: '',
          metadata: {
            pilot_type: '',
            pilot_inward_time: null,
            pilot_outward_time: null,
            pilot_disembark_inward_time: null,
            pilot_disembark_outward_time: null,
            pilot_inward_shifting_time: null,
            pilot_outward_shifting_time: null,
            arrange_by_owner: false,
            tax: ''
          }
        },
        arrival_calculated_amount: 0,
        suppliersList: [],
        portAgeItems: [1,2,3,4,5],
        anchorageItems: [1,2,3,4,5],
        taxes: ['0%', '9%']
      };
    },
    methods: {
      removeServiceEntry(index, serviceId) {
        if (!serviceId) {
          this.pilotages.splice(index, 1);
          return;
        }
        this.loading = true;
        this.$api.operation_billed_items.remove_service_entry(serviceId, { index })
          .then(() => {
            const indexOfService = this.servicesOpted.findIndex(s => s.id === serviceId);
            if (indexOfService !== -1) {
              this.servicesOpted.splice(indexOfService, 1);
            }
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Service entry removed successfully',
            });
            this.pilotages.splice(index, 1);
          })
          .catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      parseDateValue(dateValue) {
        if (!dateValue || dateValue === '' || dateValue === 'null' || dateValue === 'undefined') {
          return null;
        }
        
        if (dateValue instanceof Date) {
          return !isNaN(dateValue.getTime()) ? dateValue : null;
        }
        
        const date = new Date(dateValue);
        return !isNaN(date.getTime()) ? date : null;
      },
      sanitizePilotageDateFields() {
        this.pilotages.forEach((pilotage, index) => {
          if (!pilotage.metadata) {
            pilotage.metadata = {};
          }
          
          const dateFields = [
            'pilot_inward_time',
            'pilot_outward_time',
            'pilot_disembark_inward_time',
            'pilot_disembark_outward_time',
            'pilot_inward_shifting_time',
            'pilot_outward_shifting_time'
          ];
          
          dateFields.forEach(field => {
            const sanitizedValue = this.parseDateValue(pilotage.metadata[field]);
            if (pilotage.metadata[field] !== sanitizedValue) {
              this.$set(pilotage.metadata, field, sanitizedValue);
            }
          });
        });
      },
      async submit() {
        this.sanitizePilotageDateFields();
        await this.$nextTick();
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      initServiceOptedDetails() {
        const services = _.filter(this.servicesOpted, { bill_type: 'Pilotage' });
        if (services.length) {
          const newServices = services.filter(service => 
              service.card_id !== null || (service.card_id === null && service.id) || (service.card_id === null && service.metadata.arrange_by_owner === true)
            );
          if (newServices.length > 0) {
            this.pilotages = newServices.map(service => {
              service.metadata.arrange_by_owner = service.metadata.arrange_by_owner || false;
              const metadata = { ...service.metadata };
              
              const dateFields = [
                'pilot_inward_time',
                'pilot_outward_time',
                'pilot_disembark_inward_time',
                'pilot_disembark_outward_time',
                'pilot_inward_shifting_time',
                'pilot_outward_shifting_time'
              ];
              
              dateFields.forEach(field => {
                const dateValue = metadata[field];
                if (dateValue && dateValue !== '' && dateValue !== 'null' && dateValue !== 'undefined') {
                  const date = new Date(dateValue);
                  metadata[field] = !isNaN(date.getTime()) ? date : null;
                } else {
                  metadata[field] = null;
                }
              });
              
              return {
                ...service,
                amount: service.amount ? parseFloat(service.amount).toFixed(2) : 0,
                metadata
              };
            });
          } else {
            this.pilotages = [JSON.parse(JSON.stringify(this.serviceOptForm))];
          }
        } else {
          this.addPilotage();
        }
      },
      populateSuppliers() {
        Promise.all([
          this.$api.service_catalogs.get_suppliers_list('Pilotage')
            .then((response) => {
              this.suppliersList = response.suppliers;
              this.serviceOptForm.service_catalog_id = response.service_catalog_id;
              this.addPilotage();
              this.initServiceOptedDetails();
            })
          ]).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      async saveDetails() {
        if(!(await this.submit())) return;
        
        this.sanitizePilotageDateFields();
        await this.$nextTick();
        await this.$nextTick();
        
        const servicesToSave = this.pilotages.map(service => {
          const serviceCopy = JSON.parse(JSON.stringify(service));
          serviceCopy.service_catalog_id = this.serviceOptForm.service_catalog_id;
          serviceCopy.operation_id = this.operation.id;
          const cleanedMetadata = this.cleanupMetadata(serviceCopy);
          
          const dateFields = [
            'pilot_inward_time',
            'pilot_outward_time',
            'pilot_disembark_inward_time',
            'pilot_disembark_outward_time',
            'pilot_inward_shifting_time',
            'pilot_outward_shifting_time'
          ];
          
          dateFields.forEach(field => {
            if (cleanedMetadata[field]) {
              const date = new Date(cleanedMetadata[field]);
              if (!isNaN(date.getTime())) {
                cleanedMetadata[field] = date.toISOString();
              } else {
                cleanedMetadata[field] = null;
              }
            }
          });
          
          serviceCopy.metadata = cleanedMetadata;

          return serviceCopy;
        });
        
        this.loading = true;

        // Loop through pilotages array to save each service
        Promise.all([
          ...[...servicesToSave].map(service => {
            const apiType = service.id ? "update" : "save_service";
            return this.$api.operation_billed_items[apiType](service, true)
          })
        ]).then((response) => {
          response.forEach(service => {
            service = service.operation_billed_item;
            const indexOfService = this.servicesOpted.findIndex(s => s.id === service.id);
            if (indexOfService !== -1) {
              this.$set(this.servicesOpted, indexOfService, service);
            } else {
              this.servicesOpted.push(service);
            }
          });
          this.initServiceOptedDetails();
          this.$store.dispatch('setAlert', {
            status: 'success',
            show: true,
            message: 'Pilotage service updated successfully',
          });
        }).catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
        }).finally(() => (this.loading = false));
      },
      addPilotage() {
        const newPilotage = JSON.parse(JSON.stringify(this.serviceOptForm));
        this.pilotages.push(newPilotage);
      },
      onPilotTypeChange(index) {
        const pilotage = this.pilotages[index];
        pilotage.metadata = Object.assign(pilotage.metadata, {
          pilot_inward_time: null,
          pilot_outward_time: null,
          pilot_disembark_inward_time: null,
          pilot_disembark_outward_time: null,
          pilot_inward_shifting_time: null,
          pilot_outward_shifting_time: null
        });
      },
      cleanupMetadata(service) {
        const pilotType = service.metadata.pilot_type;
        const cleanedMetadata = { ...service.metadata };
        
        // Remove time fields that are not needed based on pilot type
        if (pilotType === 'Inward') {
          delete cleanedMetadata.pilot_outward_time;
          delete cleanedMetadata.pilot_disembark_outward_time;
          delete cleanedMetadata.pilot_inward_shifting_time;
          delete cleanedMetadata.pilot_outward_shifting_time;
        } else if (pilotType === 'Outward') {
          delete cleanedMetadata.pilot_inward_time;
          delete cleanedMetadata.pilot_disembark_inward_time;
          delete cleanedMetadata.pilot_inward_shifting_time;
          delete cleanedMetadata.pilot_outward_shifting_time;
        } else if (pilotType === 'Shifting') {
          delete cleanedMetadata.pilot_inward_time;
          delete cleanedMetadata.pilot_outward_time;
          delete cleanedMetadata.pilot_disembark_inward_time;
          delete cleanedMetadata.pilot_disembark_outward_time;
        } else if (pilotType === 'Cancellation') {
          delete cleanedMetadata.pilot_inward_time;
          delete cleanedMetadata.pilot_outward_time;
          delete cleanedMetadata.pilot_disembark_inward_time;
          delete cleanedMetadata.pilot_disembark_outward_time;
          delete cleanedMetadata.pilot_inward_shifting_time;
          delete cleanedMetadata.pilot_outward_shifting_time;
        }
        
        return cleanedMetadata;
      },
      // initCalculation () {
      //   if (this.serviceOptFormArrival.metadata.duration) {
      //     const arrivalAmount = this.calculateAmount(this.serviceOptFormArrival.metadata.duration, this.operation.gross_tonnage, this.serviceOptFormArrival.metadata.rush_request);
      //     this.arrival_calculated_amount = parseFloat(arrivalAmount).toFixed(2);
      //   }
      // },
      // calculateAmount(duration, grossTonnage, flag) {
      //   const priceMapping = [
      //     [0, 6000, 216.50, 108.25],
      //     [6000, 12000, 240, 120],
      //     [12000, 20000, 264.50, 132.25],
      //     [20000, 30000, 300.50, 150.25],
      //     [30000, 40000, 336, 168],
      //     [40000, 50000, 372, 186],
      //     [50000, 60000, 408, 204]
      //   ];
      //   let amount = 0;
      //   priceMapping.forEach(priceMap => {
      //     if (priceMap[0] < grossTonnage && grossTonnage <= priceMap[1]) {
      //       if (duration > 1) {
      //         amount = priceMap[2] + (priceMap[3] * ((duration * 2) - 2));  
      //       } else {
      //         amount = priceMap[2] * duration
      //       }
      //     }
      //   });
      //   if (grossTonnage > 60000) {
      //     if (duration > 1) {
      //       amount = 444 + (222 * ((duration * 2) - 2));  
      //     } else {
      //       amount = 444 * duration;
      //     }
      //   }
      //   if (flag) {
      //     amount = amount * 1.5;
      //   }
      //   return amount;
      // },
      // updateArrivalDuration() {
      //   if (this.serviceOptFormArrival.metadata.pilot_disembark_inward_time && this.serviceOptFormArrival.metadata.pilot_inward_time) {
      //     const diffMs = this.serviceOptFormArrival.metadata.pilot_disembark_inward_time - this.serviceOptFormArrival.metadata.pilot_inward_time;
      //     const hours = (Math.floor(diffMs / 86400000) * 24) + Math.floor((diffMs % 86400000) / 3600000);
      //     const minutesPercent = Math.round((((diffMs % 86400000) % 3600000) / 60000) / 60 * 100);
      //     this.serviceOptFormArrival.metadata.duration = parseFloat(`${hours}.${minutesPercent}`);
      //     this.initCalculation();
      //   }
      // },
    },
    computed: {
      requiredRules() {
        return (index) => {
          const pilotage = this.pilotages[index];
          if (this.isDraft || (this.operation && this.operation.is_draft) || (pilotage && pilotage.metadata.arrange_by_owner)) {
            return [];
          } else {
            return [this.rules.required];
          }
        };
      },
      amountRules() {
        return (index) => {
          const pilotage = this.pilotages[index];
          if (pilotage && pilotage.metadata.arrange_by_owner) {
            return [this.rules.negative];
          } else {
            if (this.isDraft || (this.operation && this.operation.is_draft)) {
              return [this.rules.required, this.rules.negative];
            } else {
              return [this.rules.negative];
            }
          }
        };
      },
      supplierRules() {
        return (index) => {
          const pilotage = this.pilotages[index];
          if (pilotage && pilotage.metadata.arrange_by_owner) {
            return [];
          } else {
            return [this.rules.required];
          }
        };
      },
      // arrivalHintText() {
      //   if (Number(this.serviceOptFormArrival.amount) != this.arrival_calculated_amount) {
      //     return `Pilotage service charges differs from calculated amount (${this.arrival_calculated_amount})`;
      //   } else {
      //     return "";
      //   }
      // }
    },
    watch: {
      operation(value) {
        this.handleOperationInit();
      }
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>